export function createSessionSocket(io, endpoint, getToken) {
    const socket = io(endpoint, { autoConnect: false });
    socket.auth = callback => {
        const token = getToken();
        // Avoid disconnecting a socket that already used this credential at login.
        socket.sessionToken = token;
        callback(token ? { token } : {});
    };
    socket.connect();
    return socket;
}
